// ?projectId=7
export function getProjectId() {
  // Get project id as string from query string and return undefiend if no id is found
  const projectIdQuery = window.location.search.toLowerCase().match(/projectid=([^&]*)/)?.[1]

  // Pars the string project id into a number, returns NaN if provided id is underfined
  const projectId = Number(projectIdQuery)

  // If project id is undefeind, we have wrong url
  if (isNaN(projectId)) {
    throw Error(
      'No project id found. Please use http://url.to.app/?projectId=[projectId] as root url'
    )
  }
  return projectId
}
